import { __assign } from 'tslib';
import { buttons } from './buttons.js';

var accordionItem = {
    base: {
        "[data-arrow-icon]": {
            color: "black.60",
            transition: "transform ease-in-out",
            transitionDuration: 5,
            mr: 4,
        },
        "&[data-is-open=true] [data-arrow-icon]": {
            transform: "rotate(90deg)",
        },
        "&[data-is-open=false] [data-arrow-icon]": {
            transform: "scaleY(1)",
        },
        '[data-arrow-position="right"][data-arrow-icon]': {
            mr: 0,
            ml: 4,
        },
    },
    variants: {
        size: {
            sm: {
                font: "sm",
            },
            md: {
                font: "md",
            },
            lg: {
                font: "lg",
            },
        },
    },
};
var accordionButton = __assign(__assign({}, buttons), { base: __assign(__assign({}, buttons.base), { width: "100%", justifyContent: "start", borderColor: "black.20", transition: "250ms ease-out", "&[data-is-open=true]": {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        } }) });
var accordionButtonLabel = {
    base: { flex: 1, textAlign: "left" },
};
var accordionContent = {
    base: {
        border: "1px solid",
        borderColor: "black.20",
        borderRadius: 3,
        borderTop: 0,
        p: 4,
        transition: "250ms ease-out",
        "&[data-is-open=true]": {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
    },
};

export { accordionButton, accordionButtonLabel, accordionContent, accordionItem };
//# sourceMappingURL=accordion.js.map
